import { useEffect, useContext } from "react";
import { StateContext, actions } from "../../state";
import React from "react";
import { useTranslation } from "react-i18next";
import { languageOptions } from "../../utils/i18n";
import { logger } from "../../utils/logging";
import { LOGGING } from "../../utils/enums";
import { get } from 'lodash/object';

export const ChooseLanguage = () => {
  const [{configuration, payment}, dispatch] = useContext(StateContext); // eslint-disable-line no-unused-vars
  const [t, i18n] = useTranslation(); // eslint-disable-line no-unused-vars
  const currentlySelectedLanguage = i18n.language && get(languageOptions.filter(language => language.value === i18n.language)[0], 'value');

  useEffect(() => {
    logger({
      event: LOGGING.EVENTS.LANGUAGE_SELECTOR_OPENED,
      currentLanguage: currentlySelectedLanguage,
      programId: payment.programId,
      programName: configuration.programName,
    });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <div className="choose-language">
      <div className="language-options">
        {languageOptions.map(language => (
          <div
            key={language.value}
            className="language-option"
            onClick={() => {
              logger({
                event: LOGGING.EVENTS.LANGUAGE_CHANGED,
                currentLanguage: currentlySelectedLanguage,
                requestedLanguage: language.value,
                programId: payment.programId,
                programName: configuration.programName,
              });
              i18n.changeLanguage(language.value);
              window.localStorage.removeItem('seenSystemNotifications'); // when the user switches languages we should re-show any notifications which were previously delivered in a non-native language
              dispatch(actions.modals.popModal());
              dispatch(actions.forceRefresh())
            }}
          >
            <span className="radio-label"><input type="radio" readOnly name="selected-language" value={language.value} checked={i18n.language === language.value}/><span className="label">{language.label}</span></span>
            <span><img className="icon" src={language.icon} alt=""/></span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default ChooseLanguage;
